import { status } from "skin/event/status";

const fn = (type, data) => {
  data.setValue("val", type === "promo" ? "промокод" : "бонусная система");
  return status.action;
};

export default function data(obj, ms, story, data, d, action) {
  const type = data.curData.values.fld["owner.type"];
  if (type) fn(type, data);
  return status.action;
}
